import { useEffect } from "react";
import { PropTypes } from 'prop-types';
import PreviewButton from './PreviewButton';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useCookies } from 'react-cookie';
import Loader from './Loader';
import ButtonGroup from './ButtonGroup';
import { useNavigate } from "react-router-dom";
import { usePlace, useUser } from "../api/queries";
import { trackEventSegment } from '../utils/segmentUtils';
import ENV from '../constants/envConstants';
import ReactSwal from '../utils/swalUtils';
import ButtonAnchor from './ButtonAnchor';
import Button from './Button';
import { getMenuUrl } from '../utils/queryUtils';
import { ThemeProvider } from "styled-components";
import breakpoints from "../constants/breakpoints";
import { menuPublished } from "../api/mutations";
import { useMutation } from "react-query";

function FinalStep(props) {
  let navigate = useNavigate();

  const [cookies] = useCookies(["placeId"]);

  const [mutate] = useMutation(menuPublished);

  const { data: user } = useUser();

  const { isLoading, isError, data, error } = usePlace(cookies.placeId);

  useEffect(() => {
    props.setHeader("You’re almost finished!");
    props.setSubheader(
      "Your menu is currently in draft mode. Before you publish it, press the preview button to see if you want to make any changes."
    );
    return function cleanup() {
      props.setHeader("");
      props.setSubheader("");
    };
  });

  const handleGoPrev = () => {
    ReactSwal.close();
    if (data.menu_pdf) {
      navigate("/menu-builder/pdf-menu");
    } else {
      navigate(-1);
    }
  };

  const approvalPopupHtml = () => {
    return (
      <ThemeProvider theme={breakpoints}>
        <p style={{ marginBottom: "1em" }}>
          Your menu has been published! To make any changes and to generate a QR code please go to the dashboard.
        </p>
        <ButtonAnchor
          hasMargin={false}
          text="Go to dashboard"
          href={ENV.DASHBOARD_URL}
          onClick={() => trackEventSegment("Clicked go to dashboard (Published)")}
        />
        <div style={{ marginBottom: "1em" }} />
        <ButtonAnchor
          hasMargin={false}
          inversed={true}
          text="View digital menu"
          onClick={() => trackEventSegment("Clicked digital menu button (Published)")}
          href={getMenuUrl(cookies.placeId)}
        />
      </ThemeProvider>
    );
  };
  const approvalSubmit = async () => {
    trackEventSegment("Published menu");
    mutate({ placeId: cookies.placeId });
    ReactSwal.fire({
      title: "Menu successfully published  🎉",
      html: approvalPopupHtml(),
      padding: "3.5rem",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      width: "50rem",
    });
  };

  const keepEdting = (aysnc) => {
    trackEventSegment("Clicked keep editing");
    ReactSwal.fire({
      title: "Keep editing in dashboard, or go back?",
      showConfirmButton: false,
      width: "50rem",
      padding: "3.5rem",
      html: (
        <ThemeProvider theme={breakpoints}>
          <div style={{ marginBottom: "1.5em" }} />
          <ButtonGroup>
            <Button hasMargin={false} inversed={true} text="Go back" onClick={() => handleGoPrev()} />
            <ButtonAnchor
              hasMargin={false}
              text="Edit in dashboard"
              href={ENV.DASHBOARD_URL}
              onClick={() => trackEventSegment("Clicked edit in dashboard")}
            />
          </ButtonGroup>
        </ThemeProvider>
      ),
    });
  };

  if (isLoading || !user) {
    return <Loader />;
  }

  if (isError) {
    return <p> {error.message} </p>;
  }

  if (cookies.placeId === undefined) {
    navigate("/business-profile");
  }
  return (
    <>
      <PreviewButton
        icon={faEye}
        title="Preview your menu"
        subtitle={"View the draft version of your digital menu"}
        href={data.preview_url}
      />
      <ButtonGroup halfWidth={true}>
        <Button type="button" onClick={() => keepEdting()} inversed={true} text="Keep Editing" />
        <Button type="button" text="Publish menu" onClick={() => approvalSubmit()} />
      </ButtonGroup>
    </>
  );
}


FinalStep.propTypes = {
    setHeader: PropTypes.func.isRequired,
    setSubheader: PropTypes.func.isRequired,
};

export default FinalStep;
